/* Guide pages: tap-to-enlarge for illustrated step photos + reference diagrams.
   Self-gating — does nothing unless a guide image is on the page. No deps.
   The thumbnails are CSS-cropped (object-fit:cover) versions of full-res PNGs,
   so the same src is shown full-size in a native <dialog> lightbox. */
(function () {
  function init() {
    var imgs = document.querySelectorAll('.ifg-step__media img, .ifg-diagram img');
    if (!imgs.length) return;

    var dlg = document.createElement('dialog');
    dlg.className = 'ifx';
    dlg.setAttribute('aria-label', 'Enlarged image');
    dlg.innerHTML =
      '<button type="button" class="ifx__close" aria-label="Close">×</button>' +
      '<figure class="ifx__fig"><img class="ifx__img" alt=""><figcaption class="ifx__cap"></figcaption></figure>';
    document.body.appendChild(dlg);

    var dimg = dlg.querySelector('.ifx__img');
    var dcap = dlg.querySelector('.ifx__cap');

    function open(img) {
      dimg.src = img.currentSrc || img.src;
      dimg.alt = img.alt || '';
      var cap = '';
      var step = img.closest('.ifg-step');
      if (step) {
        var n = step.querySelector('.ifg-step__num');
        var t = step.querySelector('.ifg-step__title');
        cap = [n && n.textContent, t && t.textContent].filter(Boolean).join(' · ');
      } else {
        var fig = img.closest('figure');
        var fc = fig && fig.querySelector('figcaption');
        if (fc) cap = fc.textContent;
      }
      dcap.textContent = cap;
      dcap.hidden = !cap;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    }
    function close() { dlg.close ? dlg.close() : dlg.removeAttribute('open'); }

    imgs.forEach(function (img) {
      var trigger = img.closest('.ifg-step__media') || img;
      trigger.classList.add('ifx-trigger');
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.setAttribute('aria-label', (img.alt || 'Image') + ' — tap to enlarge');
      trigger.addEventListener('click', function () { open(img); });
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(img); }
      });
    });

    dlg.querySelector('.ifx__close').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
